import React, { FC, forwardRef } from 'react';

import { CaretUpIconProps } from './types';

export const CaretUpIcon: FC<CaretUpIconProps> = forwardRef<
  SVGSVGElement,
  CaretUpIconProps
>(({ className }, ref) => {
  return (
    <svg
      width="28"
      height="9"
      viewBox="0 0 28 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      ref={ref}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8212 7.51129L6.63009 2.84904C5.05843 1.0463 3 -0.00046587 0 -0.00046587C4 -0.00146593 24 -0.00046587 28 -0.00046587C25 -0.00046587 22.8707 1.0463 21.299 2.84904L17.1079 7.51129C16.1474 8.56806 15.397 8.99853 14 8.99853C12.603 8.99853 11.7817 8.56806 10.8212 7.51129Z"
        fill="white"
      />
    </svg>
  );
});

CaretUpIcon.displayName = 'CaretUpIcon';
